import Cookies from 'js-cookie'
import {Link, withRouter} from 'react-router-dom'
import {BsSun} from 'react-icons/bs'
import {FaMoon} from 'react-icons/fa'
import Popup from 'reactjs-popup'

import './index.css'

import {
  NavHeader,
  WebsiteLogo,
  ContentContainer,
  ContentListItem,
  ThemeButton,
  ProfileImage,
  LogoutButton,
  ModalContainer,
  ModalDesc,
  ButtonContainer,
  CloseButton,
  ConfirmButton,
  AlignColumn,
} from './styledComponents'

import CartContext from '../../context/CartContext'

const Header = props => {
  const onClickLogout = () => {
    const {history} = props
    Cookies.remove('jwt_token')
    history.replace('/login')
  }

  return (
    <CartContext.Consumer>
      {value => {
        const {isDarkTheme, onChangeTheme} = value

        const onClickChangeTheme = () => {
          onChangeTheme()
        }

        const bgColor = isDarkTheme ? '#181818' : '#f9f9f9'

        const textColor = isDarkTheme ? '#f9f9f9' : '#181818'

        const websiteLogo = isDarkTheme
          ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-dark-theme-img.png'
          : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png'

        return (
          <NavHeader bgColor={bgColor}>
            <Link to="/">
              <WebsiteLogo src={websiteLogo} alt="website logo" />
            </Link>
            <ContentContainer>
              <ContentListItem>
                <ThemeButton
                  data-testid="theme"
                  color={textColor}
                  onClick={onClickChangeTheme}
                >
                  {isDarkTheme ? <BsSun /> : <FaMoon />}
                </ThemeButton>
              </ContentListItem>
              <ContentListItem>
                <ProfileImage
                  src="https://assets.ccbp.in/frontend/react-js/nxt-watch-profile-img.png"
                  alt="profile"
                />
                <Popup
                  modal
                  trigger={
                    <LogoutButton type="button" data-testid="iconButton">
                      Logout
                    </LogoutButton>
                  }
                  className="popup-content"
                >
                  {close => (
                    <ModalContainer>
                      <AlignColumn>
                        <ModalDesc>Are you sure, you went to logout?</ModalDesc>
                        <ButtonContainer>
                          <CloseButton
                            type="button"
                            data-testid="closeButton"
                            onClick={() => close()}
                          >
                            Cancel
                          </CloseButton>
                          <ConfirmButton type="button" onClick={onClickLogout}>
                            Confirm
                          </ConfirmButton>
                        </ButtonContainer>
                      </AlignColumn>
                    </ModalContainer>
                  )}
                </Popup>
              </ContentListItem>
            </ContentContainer>
          </NavHeader>
        )
      }}
    </CartContext.Consumer>
  )
}

export default withRouter(Header)
